import { EditorDisplayConfig } from '@editor/interfaces'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { merge } from 'lodash'

import { DefaultEditorDisplayConfig } from '../constants'

interface EditorSettings {
  /**
   * Editor display settings
   */
  display: EditorDisplayConfig
}

const initialState: EditorSettings = {
  display: DefaultEditorDisplayConfig,
}

const slice = createSlice({
  name: 'editor/settings',
  initialState,
  reducers: {
    setDisplaySettings(state, action: PayloadAction<EditorDisplayConfig>) {
      state.display = action.payload
    },
    patchEditorDisplaySettings(state, action: PayloadAction<RecursivePartial<EditorDisplayConfig>>) {
      state.display = merge({}, state.display, action.payload)
    },
  },
})

export const { setDisplaySettings, patchEditorDisplaySettings } = slice.actions
export default slice.reducer
